<style lang="less" scoped>
  @import "../../vars.less";

  .login {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    padding: @space-large;
    line-height: 0;
    & > * {
      line-height: normal;
    }
    background-image: url("/images/bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left bottom;
  }
  .logo {
    width: 40%;
  }
  .lang-container {
    margin-top: @space-large;
    color: @primary-color;
    font-size: 18px;
    text-align: right;
  }
  .content {
    position: absolute;
    width: 100%;
    padding: 0 @space-large;
    top: 55%;
    left: 0;
    transform: translateY(-50%);
  }
  .core {
    width: 100%;
    // height: 300px;
    background-color: rgba(255, 255, 255, .6);
  }
  .tabs {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .tab {
    position: relative;
    width: 50%;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    border-top: 3px solid @primary-color;
    background-color: @primary-color;
  }
  .tab.active {
    border-top: 3px solid @dark-color;
    background: none;
    color: @text-color;
  }
  .tab-icon {
    position: absolute;
    font-size: 24px;
    left: @space-normal;
    top: 50%;
    transform: translateY(-50%);
  }
  .login-form {
    min-height: 50px;
    margin-top: @space-large;
    border: 1px solid transparent;
  }
  .form-item {
    // padding-left: @space-large;
    // padding-right: @space-large;
    background: none;
    & > :first-child {
      margin-right: @space-large;
    }
  }
  .forget-pwd {
    font-size: 14px;
    text-align: right;
    padding: @space-normal;
    color: @primary-color;
  }
  .btn-container {
    padding: @space-normal;
    & > * {
      margin-bottom: @space-normal;
    }
  }
  .divider {
    padding-left: @space-normal;
    padding-right: @space-normal;
  }
  .login-btn,
  .myid-btn {
    font-size: 16px;
  }

  .myid-btn {
    color: @primary-color;
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0;
    margin: 0;
    text-align: center;
    font-size: 12px;
    line-height: 22px;
    color: @text-color;
    background-color: rgba(255, 255, 255, .3);
  }

</style>

<template>
  <div class="login">
    <img alt="Siemens logo" src="/images/logo.svg" class="logo">
    <div class="lang-container">
      <van-popover v-model="showPopover"
        trigger="click" :actions="langs" placement="bottom-end" @select="onLangChange">
        <template #reference>
          {{ $i18n.locale.toUpperCase() }}
          <van-icon name="arrow-down"/>
        </template>
      </van-popover>
    </div>
    <div class="content" v-if="mode !== 'find' && mode !== 'reset'">
      <div class="core">
        <ul class="tabs">
          <li class="tab" :class="{
            'active': mode === 'normal'
          }" @click="() => toggleLoadingMode('normal')">
            <van-icon name="user-o"  class="tab-icon" />
            <span class="tab-name">
              {{ $t('账号登录') }}
            </span>
          </li>
          <li class="tab" :class="{
            'active': mode === 'phone'
          }" @click="() => toggleLoadingMode('phone')">
            <van-icon name="phone-o" class="tab-icon" />
            <span class="tab-name">
              {{ $t('手机登录') }}
            </span>
          </li>
        </ul>
        <div class="login-form" v-show="mode === 'normal'">
          <van-form label-width="40px" @submit="onNormalSubmit">
            <van-field class="form-item" size="large"
              v-model="normal.username"
              name="username"
              :placeholder="$t('用户名/手机号')"
              left-icon="manager"
            />
            <van-field class="form-item" size="large"
              v-model="normal.password"
              :type="!showPwd ? 'password' : 'text'"
              left-icon="lock"
              name="password"
              :placeholder="$t('密码')"
              :right-icon="showPwd ? 'eye-o' : 'closed-eye'"
              @click-right-icon="() => showPwd = !showPwd"
            />
            <div class="forget-pwd">
              <span style="padding: 0 16px" @click="() => mode = 'find'">
                {{ $t('忘记密码') }}
              </span>
            </div>
            <div class="btn-container" style="padding-bottom: 0;">
              <van-button block type="info" class="login-btn"
                native-type="submit" :loading="normalLoading"
                :loading-text="$t('正在登录...')"
                :disabled="!loginAvailiable">
                {{ $t('登录') }}
              </van-button>
            </div>
          </van-form>
        </div>
        <div class="login-form" v-show="mode === 'phone'">
          <van-form @submit="onPhoneSubmit" label-width="40px">
            <van-field class="form-item" size="large"
              v-model="phone.phoneNumber" type="tel"
              name="phoneNumber"
              :placeholder="$t('手机号')"
              left-icon="phone-circle" />
            <van-field class="form-item" size="large"
              v-model="phone.verificationCode"
              left-icon="chat"
              name="verificationCode"
              :placeholder="$t('验证码')">
              <template #button>
                <verification-code-button type="login"
                  mode="phone" name="login" :contact="phone.phoneNumber"
                  :disabled="!phone.phoneNumber" />
              </template>
            </van-field>
            <div class="btn-container" style="padding-bottom: 0;">
              <van-button block type="info" class="login-btn"
                native-type="submit" :loading="phoneLoading"
                :disabled="!phone.phoneNumber || !phone.verificationCode">
                {{ $t('登录') }}
              </van-button>
            </div>
          </van-form>
        </div>
        <van-divider class="divider">{{ $t('or') }}</van-divider>
        <div class="btn-container" style="padding-top: 0;">
          <van-button block type="default" class="myid-btn" :disabled="loginLoading"
            icon="idcard" :url="myIdUrl" :loading="myIdLoginLoading">
            {{ $t('MyID(Siemens Employees)') }}
          </van-button>
          <!-- azure ad登录 -->
          <van-button block type="default" class="myid-btn" :disabled="loginLoading"
            icon="idcard" :url="azureIdUrl" :loading="AzureIdLoginLoading">
            {{ $t('Microsoft Azure') }}
          </van-button>
        </div>
      </div>
    </div>
    <div class="content" v-if="mode === 'find'">
      <div class="core">
        <ul class="tabs">
          <li class="tab active">
            <van-icon name="browsing-history-o"  class="tab-icon" />
            <span class="tab-name">
              {{ $t('找回密码') }}
            </span>
          </li>
        </ul>
        <div class="login-form">
          <van-form @submit="next" label-width="40px">
            <van-field class="form-item" size="large"
              v-model="find.contact"
              name="contact"
              :placeholder="$t('邮箱/手机号')"
              left-icon="manager" />
            <van-field class="form-item" size="large"
              v-model="find.verificationCode"
              left-icon="chat"
              name="verificationCode"
              :placeholder="$t('验证码')">
              <template #button>
                <verification-code-button type="resetpwd"
                  name="find" :contact="find.contact"
                  :disabled="!find.contact" />
              </template>
            </van-field>
            <div class="btn-container" style="padding-bottom: 0;">
              <van-button block type="info" class="login-btn"
                native-type="submit" :loading="nextLoading"
                :disabled="!find.contact || !find.verificationCode">
                {{ $t('下一步') }}
              </van-button>
              <van-button block plain class="login-btn"
                native-type="button" @click="() => mode = 'normal'">
                {{ $t('取消') }}
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <div class="content" v-if="mode === 'reset'">
      <div class="core">
        <ul class="tabs">
          <li class="tab active">
            <van-icon name="records"  class="tab-icon" />
            <span class="tab-name">
              {{ $t('重置密码') }}
            </span>
          </li>
        </ul>
        <div class="login-form">
          <van-form @submit="startReset">
            <van-field v-if="needAccount" class="form-item" size="large"
              v-model="reset.account"
              name="account"
              :placeholder="$t('请输入用户名')"
              left-icon="manager" />
            <van-field class="form-item" size="large"
              v-model="reset.password1"
              left-icon="lock"
              :right-icon="showResetPwd ? 'eye-o' : 'closed-eye'"
              @click-right-icon="() => showResetPwd = !showResetPwd"
              :type="!showResetPwd ? 'password' : 'text'"
              name="password1"
              :placeholder="$t('请输入新密码')" />
            <van-field class="form-item" size="large"
              v-model="reset.password2"
              left-icon="lock"
              :right-icon="showResetPwd ? 'eye-o' : 'closed-eye'"
              @click-right-icon="() => showResetPwd = !showResetPwd"
              :type="!showResetPwd ? 'password' : 'text'"
              name="password2"
              :placeholder="$t('请再次输入新密码')" />
            <div class="btn-container" style="padding-bottom: 0;">
              <van-button block type="info" class="login-btn"
                native-type="submit" :loading="resetLoading"
                :disabled="(needAccount && !reset.account) || !reset.password1 || !reset.password2">
                {{ $t('确定') }}
              </van-button>
              <van-button block plain class="login-btn"
                native-type="button" @click="() => mode = 'normal'">
                {{ $t('取消') }}
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <p class="footer">
      {{ $t('西门子中国') }} &copy; {{ $t('智能基础设施集团') }} 2014-2021
    </p>
  </div>
</template>

<script>
import { Popover, Icon, Form, Field, Button, Divider, Toast, Notify } from 'vant'
import VerificationCodeButton from '../../components/VerificationCodeButton.vue'
import { isEmail, isPhone } from '../../utils/contact-type'
import { LS_KEYS } from '../../constants'
import isValidPassword from '../../utils/valid-password'
import ls from '../../utils/local-storage'

export default {
  name: 'login',
  components: {
    'van-popover': Popover,
    'van-icon': Icon,
    'van-form': Form,
    'van-field': Field,
    'van-button': Button,
    'van-divider': Divider,
    VerificationCodeButton
  },
  data () {
    return {
      showPopover: false,
      mode: 'normal', // 'normal', 'phone', 'find', 'reset'
      showPwd: false,
      normal: {
        username: '',
        password: ''
      },
      normalLoading: false,
      phone: {
        phoneNumber: '',
        verificationCode: ''
      },
      phoneLoading: false,
      find: {
        contact: '',
        verificationCode: ''
      },
      nextLoading: false,
      reset: {
        count: '',
        password1: '',
        password2: ''
      },
      showResetPwd: false,
      resetLoading: false,
      myIdLoginLoading: false,
      AzureIdLoginLoading: false
    }
  },
  computed: {
    langs () {
      return [
        { text: 'English', value: 'en', disabled: this.$i18n.locale === 'en' },
        { text: '中文', value: 'zh', disabled: this.$i18n.locale === 'zh' }
      ]
    },
    loginAvailiable () {
      if (this.mode === 'normal') {
        return this.normal.username.trim() && this.normal.password.trim()
      } else {
        return this.phone.phoneNumber.trim() && this.phone.verificationCode.trim()
      }
    },
    needAccount () {
      return isEmail(this.find.contact)
    },
    myIdUrl () {
      const myIdUrl = window.__runtime__.myIdLoginUrl
      const redirectUrl = encodeURIComponent(window.location.href)
      let service = window.__runtime__.remoteApiAddress || 'https://si-mobile.prolliance.cn:8080'
      service = service.endsWith('/') ? service.slice(0, service.length - 1) : service
      service = encodeURIComponent(service)

      return `${myIdUrl}?sso&redirect_url=${redirectUrl}&service=${service}&auth_type=api&idp=myid`
    },
    // azure Ad登录
    azureIdUrl () {
      const myIdUrl = window.__runtime__.myIdLoginUrl
      const redirectUrl = encodeURIComponent(window.location.href)
      let service = window.__runtime__.remoteApiAddress || 'https://si-mobile.prolliance.cn:8080'
      service = service.endsWith('/') ? service.slice(0, service.length - 1) : service
      service = encodeURIComponent(service)

      return `${myIdUrl}?sso&redirect_url=${redirectUrl}&service=${service}&auth_type=api&idp=azure`
    },
    loginLoading () {
      return this.normalLoading ||
        this.phoneLoading ||
        this.myIdLoginLoading ||
        this.AzureIdLoginLoading
    }
  },
  methods: {
    onLangChange (lang) {
      this.$i18n.locale = lang.value
      ls.set(LS_KEYS.LOCALE, lang.value)
    },
    toggleLoadingMode (mode) {
      if (!this.loginLoading) {
        this.mode = mode
      }
    },
    onNormalSubmit () {
      this.$apis.auth.normalLogin(
        this.normal.username,
        this.normal.password,
        loading => (this.normalLoading = loading)
      ).then((res) => this.onLoginSuccess(res, true))
    },
    onPhoneSubmit () {
      this.$apis.auth.phoneLogin(
        this.phone.phoneNumber,
        this.phone.verificationCode,
        loading => (this.phoneLoading = loading)
      ).then(this.onLoginSuccess)
    },
    onLoginSuccess (res, hangPwd) {
      if (res && res.pgt) {
        // save pgt
        ls.set(LS_KEYS.PGT, res.pgt)
        // save pwd to root to set gesture pwd if not pki user and is normal login
        if (!res.is_pki && hangPwd) {
          this.$root.password = this.normal.password
        }
        // save username to use gesture pwd
        ls.set(LS_KEYS.ACCOUNT, res.userInfo?.account)
        ls.set(LS_KEYS.EMAIL, res.userInfo?.email)
        // save all userinfo
        ls.set(LS_KEYS.USERINFO, res.userInfo)
        // save authorization
        ls.set(LS_KEYS.AUTHORIZATION, res.authForAllOp)
        if (res.modify_pwd) {
          ls.set(LS_KEYS.NEED_MODIFY_PWD, true)
          this.$router.push({ name: 'change-password' })
        } else {
          ls.set(LS_KEYS.NEED_MODIFY_PWD, false)
          this.$router.push({ name: 'home' })
        }
      }
    },
    next () {
      let api = null

      if (isPhone(this.find.contact)) {
        api = this.$apis.auth.checkMsgCode
      }
      if (isEmail(this.find.contact)) {
        api = this.$apis.auth.checkEmailCode
      }

      if (!api) return

      api(
        this.find.contact,
        this.find.verificationCode,
        loading => (this.nextLoading = loading)
      ).then(res => {
        if (res) this.mode = 'reset'
      })
    },
    startReset () {
      if (this.reset.password1 !== this.reset.password2) {
        Toast({
          message: this.$t('两次输入的密码不一致，请重新输入'),
          duration: 3000
        })
        return
      }
      if (!isValidPassword(this.reset.password1)) {
        Toast({
          message: this.$t('密码最少10个字符，且必须包含数字、大小写字母和特殊字符中的任意三种'),
          duration: 5000
        })
        return
      }

      const data = {
        new_password_first: this.reset.password1,
        new_password_second: this.reset.password2,
        code: this.find.verificationCode,
        account: this.reset.account
      }
      if (isPhone(this.find.contact)) {
        data.phone = this.find.contact
      }
      if (isEmail(this.find.contact)) {
        data.email = this.find.contact
      }

      this.$apis.auth.resetPassword(
        data,
        loading => (this.resetLoading = loading)
      ).then(res => {
        if (res) {
          Notify({
            type: 'success',
            message: this.$t('密码重置成功，请重新登录')
          })
          ls.clear()
          this.mode = 'normal'
        }
      })
    },
    backFromCas () {
      if (
        // eslint-disable-next-line
        this.$route.query.hasOwnProperty('ticket')
      ) {
        if (this.$route.query.ticket) {
          // login success
          this.$apis.auth.loginWithTicket(
            decodeURIComponent(this.$route.query.ticket),
            loading => { this.myIdLoginLoading = loading; this.AzureIdLoginLoading = loading }
          ).then(this.onLoginSuccess)
        } else {
          // login failed
          Notify({
            type: 'warning',
            message: window.atob(this.$route.query.msg)
          })
          this.$router.replace({ name: 'login' })
        }
      }
    }
  },
  mounted () {
    this.backFromCas()
  }
}
</script>
